import { bamColors } from './colors/bamColors';
import colormap from './colors/colormap';
import { ColorPaletteState } from './types';

export const colorPaletteInitialState: ColorPaletteState = {
  colors: colormap(bamColors),
};
